exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view {\n  margin: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/json-form-view/json-form-view.component.scss
// module id = ../../../../../src/app/core/json-form/material/json-form-view/json-form-view.component.scss
// module chunks = main